import { type ConnectedPageAttributes } from './generated/ConnectedPageAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';
import whiteboardThumbnail from 'images/pages/shared-whiteboard.svg';
import notedThumbnail from 'images/pages/shared-noted.svg';

interface ConnectedPage extends ConnectedPageAttributes {}

@model
class ConnectedPage extends ApplicationModel {
  // Start auto-generated
  static typename: 'ConnectedPage' = 'ConnectedPage';
  get typename(): 'ConnectedPage' {
    return 'ConnectedPage';
  }

  static internalTypename: 'ConnectedPage' = 'ConnectedPage';
  get internalTypename(): 'ConnectedPage' {
    return 'ConnectedPage';
  }

  static inputType = 'PageAttributes!';

  static fields = {
    createdAt: attr({ readable: true }),
    description: attr({ writable: true, readable: false }),
    descriptionMarkdown: attr({ writable: true, readable: false }),
    documentDate: attr({ writable: true, readable: false }),
    documentType: attr({ writable: true, readable: true }),
    editLocked: attr({ writable: true, readable: false }),
    editorVersion: attr({ writable: true, readable: false }),
    editorWidth: attr({ writable: true, readable: false }),
    emojiValue: attr({ writable: true, readable: false }),
    id: attr({ readable: true }),
    inDiscoveryParent: attr({ writable: true, readable: false }),
    lastAccessedAt: attr({ readable: true }),
    location: attr({ writable: true, readable: false }),
    meetingDuration: attr({ writable: true, readable: false }),
    name: attr({ writable: true, readable: true }),
    position: attr({ writable: true, readable: false }),
    reviewerDocumentAccess: attr({ writable: true, readable: false }),
    showContents: attr({ writable: true, readable: false }),
    updatedAt: attr({ readable: true }),
    parent: attr.belongsTo({ writeShape: ['id'], readable: false }),
    project: attr.belongsTo({ writeShape: ['id'], readable: false }),
  };
  // End auto-generated

  get nameOrDefault() {
    return this.name;
  }

  get thumbnailUrl() {
    if (this.documentType === 'WHITEBOARD') {
      return whiteboardThumbnail;
    } else {
      return notedThumbnail;
    }
  }
}

export default ConnectedPage;
